module.exports = __webpack_public_path__ + "static/media/vmcare-light.01d25d87.svg";